<script>
import { orderReportMethods, userMethods, toasterMethods } from '@state/helpers'
import constant from '@constants/constant'
import accesslevels from '@utils/accesslevels'

export default {
  props: {
    customerId: {
      type: Number || String,
      default: '',
    },
    customerUserId: {
      type: Number || String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    productAddOns: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      errorLog: '',
      alertMessage: '',
      loanIdentifier: '',
      firstName: '',
      middleName: '',
      lastName: '',
      companyName: '',
      streetAddress: '',
      cityName: '',
      state: '',
      stateCode: '',
      zip: '',
      phoneNumber: '',
      legaldescription: '',
      coborrowerFirstName: '',
      coborrowerMiddleName: '',
      coborrowerLastName: '',
      coborrowerSelected: false,
      showSpinner: false,
      productAddon: [],
      productAddons: [],
      manualPollingStatus: 5,
      failureStatus: 3,
      borrowerType: 1,
      isCustRequestor: false,
      typeOption: [
        { text: '   Commercial', value: 1 },
        { text: '   Residential', value: 2 },
      ],
    }
  },
  computed: {
    getHeader() {
      return this.borrowerType === 1
        ? 'Commercial Information'
        : 'Residential Information'
    },
    placeholders() {
      return {
        loanIdentifier: 'Loan Identifier',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        streetAddress: 'Street Address',
        cityName: 'City Name',
        state: 'Select State',
        zip: 'xxxxx-xxxx',
        companyName: 'Company Name',
        phoneNumber: '(xxx) xxx-xxxx',
        legaldescription: 'Legal Description',
      }
    },

    states() {
      return this.$_allStates
    },

    userInfo() {
      return this.$store.state.auth.currentUser.userInfo
    },
  },
  mounted() {
    this.getFloodReportAddons()
    this.isCustRequestor = accesslevels(9)
  },
  methods: {
    ...toasterMethods,
    ...orderReportMethods,
    ...userMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },

    toggleEventParent() {
      this.coborrowerFirstName = ''
      this.coborrowerMiddleName = ''
      this.coborrowerLastName = ''
      this.coborrowerSelected = !this.coborrowerSelected
    },

    getFloodReportAddons() {
      for (var i = 0; i < this.productAddOns.length; i++) {
        this.productAddons.push({
          value: this.productAddOns[i].productAddOnId,
          text: this.productAddOns[i].name,
          checked: this.productAddOns[i].defaultScope,
          disabled: !this.productAddOns[i].changeable,
        })
        if (this.productAddOns[i].defaultScope === true) {
          this.productAddon.push(this.productAddOns[i].productAddOnId)
        }
      }
    },
    getStateCode() {
      if (this.state !== '') {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
    borrowerChange() {
      if (this.borrowerType === 1) {
        this.coborrowerSelected = false
      }
    },
    buildFloodReportRequest() {
      var borrower = {}
      var coBorrower = {}
      var business = {}

      if (this.isCustRequestor) {
        this.customerUserId = this.userInfo.userId
      }

      if (this.borrowerType === 1) {
        business = {
          Name: this.companyName,
        }
      } else {
        business = null
      }
      if (this.coborrowerSelected) {
        coBorrower = {
          FirstName: this.coborrowerFirstName,
          MiddleName: this.coborrowerMiddleName,
          LastName: this.coborrowerLastName,
          BorrowerType: 1,
        }
      } else {
        coBorrower = null
      }
      if (this.borrowerType === 2) {
        borrower = {
          FirstName: this.firstName,
          MiddleName: this.middleName,
          LastName: this.lastName,
          BorrowerType: 0,
        }
      } else {
        borrower = null
      }
      return {
        ProductAddOnsId: this.productAddon,
        BorrowerType: this.borrowerType,
        Borrower: borrower === null ? null : borrower,
        Coborrower: coBorrower === null ? null : coBorrower,
        PropertyAddress: {
          Street: this.streetAddress,
          City: this.cityName,
          StateId: this.state,
          StateCode: this.stateCode,
          Zip: this.zip,
        },
        Business: business === null ? null : business,
        Contact: {
          PhoneNumber: this.phoneNumber === '' ? '' : this.phoneNumber,
        },
        UserId: this.userInfo.userId,
        ProductId: this.productId,
        OrderForUserId: this.customerUserId,
        OrderForCustomerId: this.customerId,
        LegalDescription: this.legaldescription,
        LoanIdentifier: this.loanIdentifier,
      }
    },
    routeToFloodOrderSummary(orderId) {
      return this.$router.push({
        name: 'floodOrderSummary',
        params: {
          orderId: orderId,
          callOrigin: constant.origin.OrderReport,
          productId: this.productId,
        },
      })
    },
    onReportSubmit(selectedValue) {
      this.getStateCode()
      var isOrderReportComponentValid = false
      var isFloodReportComponentValid = false
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isFloodReportComponentValid = response
          if (isOrderReportComponentValid && isFloodReportComponentValid) {
            if ((that.firstName && that.lastName) || that.companyName !== '') {
              that.showSpinner = true
              that
                .fetchServicelinkFloodReport({
                  jsonRequestString: that.buildFloodReportRequest(),
                })
                .then((response) => {
                  if (
                    response.data !== null &&
                    response.data.responseStatus === 1 &&
                    response.data.reportByteArray !== undefined
                  ) {
                    if (response.data.responseStatus)
                      this.routeToFloodOrderSummary(response.data.orderId)
                    this.$emit('resetOrderReport')
                  } else if (
                    response.data.responseStatus === this.manualPollingStatus
                  ) {
                    this.setAlert({
                      title: constant.imageHeaderSuccess,
                      msg: response.data.message,
                      variant: constant.successMessagetype,
                    })
                    this.routeToFloodOrderSummary(response.data.orderId)
                  } else if (
                    response.data.responseStatus === this.failureStatus
                  ) {
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: response.data.message,
                      variant: constant.errorMessagetype,
                    })
                    window.location.reload()
                  } else if (
                    response.data.message !== '' &&
                    response.data.message !== null &&
                    response.data.message !== undefined
                  ) {
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: response.data.message,
                      variant: constant.errorMessagetype,
                    })
                  } else {
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: constant.errorMessage,
                      variant: constant.errorMessagetype,
                    })
                  }
                })
                .catch((error) => {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                  this.errorLog = error
                })
                .finally(() => {
                  this.showSpinner = false
                })
            } else {
              this.getModal(
                'Please enter borrower name or company name.',
                'Message'
              )
            }
          }
        })
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col sm="12 mt-4">
        <b-form-group class="mb-0">
          <b-form-checkbox
            v-for="option in productAddons"
            :key="option.value"
            v-model="productAddon"
            :value="option.value"
            :checked="option.checked"
            :disabled="option.disabled"
            name="productAddon"
            inline
            >{{ option.text }}</b-form-checkbox
          >
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="loanIdentifier"
          v-model="loanIdentifier"
          v-validate="'required'"
          validattor="^(?!')(?!`).*$"
          data-vv-as="Loan Identifier"
          type="text"
          maxlength="20"
          name="loanIdentifier"
          label-content="Loan Identifier"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('loanIdentifier'),
          }"
          :placeholder="placeholders.loanIdentifier"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('loanIdentifier') }}
        </div>
      </b-col>
      <b-col md="6">
        <BaseELabel mark-required label="Borrower Type" />

        <b-form-group>
          <b-form-radio-group
            :key="typeOption.id"
            v-model="borrowerType"
            :options="typeOption"
            class="mr-5"
            @change="borrowerChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-3" align-v="center">
      <b-col md="auto">
        <div>
          <BaseELabel :label="getHeader" :class="$style.labelSubHeading" />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col v-if="borrowerType === 1" md="3">
        <BaseEInputText
          id="companyName"
          v-model="companyName"
          v-validate="'required'"
          data-vv-as="Company Name"
          type="text"
          name="companyName"
          maxlength="100"
          label-content="Company Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('companyName'),
          }"
          :placeholder="placeholders.companyName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('companyName') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="borrowerType === 2" md="3">
        <BaseEInputText
          id="firstName"
          v-model="firstName"
          v-validate="{ required: true, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="First Name"
          type="text"
          name="firstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('firstName'),
          }"
          :placeholder="placeholders.firstName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('firstName') }} </div>
      </b-col>
      <b-col v-if="borrowerType === 2" md="3">
        <BaseEInputText
          id="middleName"
          v-model="middleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Middle Name"
          type="text"
          name="middleName"
          maxlength="50"
          label-content="Middle Name"
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('middleName') }} </div>
      </b-col>
      <b-col v-if="borrowerType === 2" md="3">
        <BaseEInputText
          id="lastName"
          v-model="lastName"
          v-validate="{
            required: true,
            regex: /^[A-Za-z0-9-]+$/,
          }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Last Name"
          type="text"
          name="lastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('lastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('lastName') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          v-validate="'required'"
          data-vv-as="Street"
          type="text"
          name="streetAddress"
          maxlength="100"
          label-content="Street"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('street'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('streetAddress') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: true, regex: /^[A-Za-z -]+$/ }"
          validattor="^[A-Za-z -]+$"
          data-vv-as="City"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('city'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('cityName') }} </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          data-vv-as="State"
          :field-id="state"
          :options="states"
          name="state"
          :placeholder="placeholders.state"
        ></BaseDropdown>
        <div class="error"> {{ errors.first('state') }} </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          data-vv-as="Zip"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('zip') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          data-vv-as="Phone #"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          :class="{
            input: true,
            'is-danger': errors.has('phoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('phoneNumber') }} </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 border-bottom">
      <b-col class="col-9">
        <BaseTextarea
          id="legaldescription"
          v-model="legaldescription"
          maxlength="255"
          name="legaldescription"
          label-content="Legal Description"
        ></BaseTextarea>
      </b-col>
    </b-row>

    <b-row v-if="borrowerType === 3">
      <b-col md="3">
        <BaseELabel label="Co-Borrower" />
        <BaseSwitch
          id="coborrowerSelected"
          v-model="coborrowerSelected"
          name="coborrowerSelected"
          class="float-left pt-2"
          checkedlbl="Yes"
          uncheckedlbl="No"
          :is-checked="false"
          @toggleEvent="toggleEventParent"
        />
      </b-col>
    </b-row>
    <b-row v-if="coborrowerSelected === true && borrowerType === 3">
      <b-col md="3">
        <BaseEInputText
          id="coborrowerFirstName"
          v-model="coborrowerFirstName"
          v-validate="{ required: true, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="First Name"
          type="text"
          name="coborrowerFirstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('coborrowerFirstName'),
          }"
          :placeholder="placeholders.firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('coborrowerFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="coborrowerMiddleName"
          v-model="coborrowerMiddleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Middle Name"
          type="text"
          name="coborrowerMiddleName"
          maxlength="50"
          label-content="Middle Name"
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('coborrowerMiddleName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="coborrowerLastName"
          v-model="coborrowerLastName"
          v-validate="{ required: true, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          data-vv-as="Last Name"
          type="text"
          name="coborrowerLastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('coborrowerLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">{{ errors.first('coborrowerLastName') }}</div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="3">
        <BaseEButton @click="onReportSubmit">
          Submit
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
